module.exports = __webpack_public_path__ + "img/instructions4.e3bf3b11.png";